import React from "react";
import { Link } from "gatsby";
import { TextLink, TextLinkTheme, Typography } from "@trussle/external-components";

import "./styles.scss";

export interface IProps {
  classNames?: string;
  url: string;
  cardText: string;
  handleClick?: (e: any) => void;
  betterV2?: boolean;
}

export const GridColumnCard: React.FC<IProps> = (props) => {
  const {
    classNames, url, cardText, handleClick,
    betterV2,
  } = props;

  return betterV2 ? (
    <TextLink
      className="gridColumnCardBetterV2"
      target="_blank"
      theme={TextLinkTheme.SECONDARY}
      href={url}
      onClick={(e) => handleClick && handleClick(e)}
    >
      {cardText}
    </TextLink>
  ) : (
    <Link
      className={`gridColumnCard ${classNames}`}
      to={url}
      onClick={(e) => handleClick && handleClick(e)}
    >
      <div className="gridColumnCard__titleContainer">
        <Typography
          variant="h6"
          component="div"
          classes="gridColumnCard__title"
        >
          {cardText}
        </Typography>
        <span className="gridColumnCard__arrow" />
      </div>
    </Link>
  );
};
